import { computed, Ref } from "@vue/composition-api";
import { asString } from "./common";

export interface RequiredAttr {
  required: Readonly<Ref<boolean>>;
  requiredError: Readonly<Ref<boolean>>;
}

export const requiredValidator = (
  inputRef: Ref<string | number>,
  inputValueDirty: Ref<boolean>
): RequiredAttr => {
  const required = computed(() => {
    const value = asString(inputRef.value);
    return value.length > 0;
  });
  return {
    required,
    requiredError: computed(() => !required.value && inputValueDirty.value)
  };
};
